import React from "react";
import { Button } from "@/components/ui/button";
import { BrandIcon } from "@/components/BrandIcon";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/radar/tierra";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      {/* Left: form */}
      <div className="flex flex-col justify-center px-8 sm:px-16 lg:px-24 py-12">
        <div className="flex items-center gap-3 mb-12">
          <BrandIcon size={40} className="shrink-0" data-testid="brand-icon-login" />
          <div>
            <p className="font-heading text-lg font-bold tracking-tight text-slate-900 leading-none" data-testid="brand-wordmark">
              LandHo<span className="text-emerald-700">!</span>
            </p>
            <p className="text-[11px] font-medium text-slate-500 leading-tight mt-0.5">
              Radar de oportunidades
            </p>
          </div>
        </div>

        <div className="max-w-md">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-emerald-700 mb-4">
            Acceso interno
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 mb-4">
            Ver lo que otros no ven.
          </h1>
          <p className="font-body text-base text-slate-600 mb-10 leading-relaxed">
            Detectá oportunidades inmobiliarias antes que la competencia:
            propiedades subvaluadas, lotes vacíos y datos oficiales del
            catastro, todo cruzado en un mapa.
          </p>

          <Button
            data-testid="login-google-btn"
            onClick={handleGoogleLogin}
            className="w-full bg-white border border-slate-300 hover:bg-slate-50 text-slate-900 rounded-none px-6 py-6 text-base font-medium transition-all flex items-center justify-center gap-3 h-auto"
          >
            <GoogleIcon />
            Iniciar sesión con Google
          </Button>

          <div className="mt-10 pt-8 border-t border-slate-200">
            <p className="text-xs uppercase tracking-[0.15em] font-bold text-slate-500 mb-3">
              Qué hace el radar
            </p>
            <ul className="space-y-2 text-sm text-slate-600 font-body">
              <li>· Escanea portales inmobiliarios y detecta subvaluaciones</li>
              <li>· Cruza lotes vacíos con datos oficiales del catastro provincial</li>
              <li>· Prioriza dueños directos y ordena por potencial de negocio</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Right: image */}
      <div className="relative hidden lg:block overflow-hidden">
        <img
          src="https://images.pexels.com/photos/15393146/pexels-photo-15393146.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200"
          alt="Córdoba Argentina"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 via-slate-900/10 to-slate-900/70" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="text-xs uppercase tracking-[0.18em] font-bold mb-3 opacity-80">
            Empezamos por Córdoba
          </p>
          <h2 className="font-heading text-3xl font-semibold leading-tight">
            El mapa se lee distinto<br />cuando ves lo que los demás pasan por alto.
          </h2>
        </div>
      </div>
    </div>
  );
}

const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);
